import React, { memo } from 'react'
import { faHexagonVerticalNftSlanted } from '@fortawesome/pro-duotone-svg-icons'

import ProgressTitle from '../shared/progressBar/ProgressTitle'

const RedeemTitle = ({ isNft, ...restProps }) => {
  return (
    <ProgressTitle icon={isNft && faHexagonVerticalNftSlanted} {...restProps} />
  )
}

export default memo(RedeemTitle)
